import AppNexus from '@components/AppNexus'
import usePageMetadata from '@hooks/usePageMetadata'
import { desktopCSS, mobileCSS, tabletCSS } from '@measures/responsive'
import { FunctionComponent } from 'react'
import styled, { css } from 'styled-components'

const StyledNewstickerAd = styled.div`
  position: fixed;
  bottom: 0;
  z-index: 12;
  display: grid;
  align-items: flex-end;
  justify-items: center;

  > aside {
    display: block;
    width: 100%;
    line-height: 0;
  }

  ${desktopCSS(css`
    width: calc(994px - 2 * 20px);
  `)}

  ${tabletCSS(css`
    width: calc(768px - 2 * 52px);
  `)}

    ${mobileCSS(css`
    width: 100%;
  `)}
`

const NewstickerAd: FunctionComponent = () => {
  const { newstickerAd, url } = usePageMetadata()

  if (!newstickerAd) {
    return null
  }

  return (
    <StyledNewstickerAd>
      <AppNexus {...newstickerAd} key={url} />
    </StyledNewstickerAd>
  )
}

export default NewstickerAd
